import _ from 'lodash';
import Skeleton from 'react-loading-skeleton';
import type LoadingDrawerProps from './types';
import './loadingDrawer.scss';
import { useLoadingDrawer } from './useLoadingDrawer';

/**
 * Skeleton placeholder shown in place of a drawer's contents while it loads. While isLoading it renders a skeleton header with the optional right icon plus fifteen body sections, each mapping the entries of dataLoading from useLoadingDrawer into pairs of randomly sized Skeleton bars; once loading ends it renders children.
 *
 * @param props - The loading flag, drawer contents to reveal when loaded and an optional right-hand icon.
 * @returns The skeleton layout while loading, otherwise the children.
 */
const LoadingDrawer = (props: LoadingDrawerProps) => {
  const { rightIcon = undefined, children, isLoading } = props;

  const { dataLoading } = useLoadingDrawer();

  const NUMBER_OF_SECTION = 15;

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-header">
          <div className="title">
            <Skeleton width="100%" height="22px" />
          </div>
          {!!rightIcon && <div className="icon-right">{rightIcon}</div>}
        </div>
        <div className="loading-body">
          {_.map(_.range(NUMBER_OF_SECTION), () => (
            <div className="loading-body__section">
              {_.map(dataLoading.current, (d) => (
                <div className="custom-skeleton" key={d as any}>
                  <Skeleton
                    width={`${_.random(50, 100)}%`}
                    height="22px"
                    style={{ marginBottom: '26px' }}
                  />
                  <Skeleton
                    width={`${_.random(50, 100)}%`}
                    height="22px"
                    style={{ marginBottom: '26px' }}
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  }

  return children;
};

export default LoadingDrawer;
